import React from 'react';
import { history } from '../_helpers/history';
import { alertActions } from '../_actions/alert.actions';
import { Route, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

export default ({ component: Component, layout: Layout, props: cProps, roles, ...rest }) => {
  const dispatch = useDispatch();

  const isAuthenticated = useSelector(state => state.authentication.isAuthenticated)
  const currentUser = useSelector(state => state.user.currentUser)

  return <Route {...rest} render={props => {
    // Authentication
    if (!isAuthenticated) {
      return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    }

    // Authorization
    if (roles && roles.indexOf(currentUser.UserType.Name) === -1) {
      history.push('/');

      dispatch(alertActions.error("Sorry, you are forbidden from accessing that resource."))
    }

    if (!Layout) {
      return <Component {...props} {...cProps} />
    }

    return <Layout {...props}><Component {...props} {...cProps} /></Layout>
  }}>

  </Route>
};